import { IconX } from '@/components/icons';
import { typeScale } from '@/lib/typography';

/** Mobile CardsBar: close, title, optional right control. */
export function LessonBar({
  title,
  onClose,
  right,
}: {
  title: string;
  onClose: () => void;
  right?: React.ReactNode;
}) {
  return (
    <header className="flex h-8 items-center justify-between">
      <div className="flex min-w-0 items-center">
        <button type="button" onClick={onClose} aria-label="Close" className="p-2 -ml-2">
          <IconX size={20} strokeWidth={2.25} />
        </button>
        <h1 className={`ml-1 truncate ${typeScale.lessonBarTitle}`}>{title}</h1>
      </div>
      {right ? <div className="ml-3 shrink-0">{right}</div> : null}
    </header>
  );
}
